"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLanguage = changeLanguage;
exports.init = init;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _reactI18next = require("react-i18next");

var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function loadLocaleBundle(bundles, locale, ns) {
  if (typeof bundles[locale][ns] === 'function') {
    return bundles[locale][ns]().then(function (data) {
      return data["default"];
    })["catch"](function (err) {
      console.error(err);
    });
  }

  return Promise.resolve(bundles[locale][ns]);
}

function init(resources, lng) {
  var defaultLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var customOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ns = Object.keys(resources[defaultLocale]);

  var options = _objectSpread({
    react: {
      transWrapTextNodes: 'span'
    },
    fallbackLng: defaultLocale,
    interpolation: {
      escapeValue: false
    },
    supportedLngs: Object.keys(resources),
    ns: ns,
    defaultNS: ns[0],
    returnEmptyString: false,
    backend: {
      loadPath: '{{lng}}|{{ns}}',
      request: function request(options, url, payload, callback) {
        try {
          var _url$split = url.split('|'),
              _url$split2 = (0, _slicedToArray2["default"])(_url$split, 2),
              _lng = _url$split2[0],
              _ns = _url$split2[1];

          loadLocaleBundle(resources, _lng, _ns).then(function (data) {
            callback(null, {
              data: JSON.stringify(data),
              status: 200
            });
          });
        } catch (e) {
          console.error(e);
          callback(null, {
            status: 500
          });
        }
      }
    }
  }, customOptions);

  if (lng && options.supportedLngs.includes(lng)) {
    options.lng = lng;
  }

  return _i18next["default"].use(_i18nextBrowserLanguagedetector["default"]).use(_i18nextHttpBackend["default"]).use(_reactI18next.initReactI18next).init(options);
}

function changeLanguage(language) {
  return _i18next["default"].changeLanguage(language);
}